<template lang="pug">
.ChallengeKeyboardInput(
  @keydown="handleKeyDown($event)"
  tabindex="0"
  ref="self"
)
  .debug(v-if="constants.IS_DEBUG")
    | preText: {{ preText }}<br>
    | backspaceCount: {{ backspaceCount }}<br>
    | wrongCount: {{ wrongCount }}<br>
    | wrongLogs: {{ wrongLogs }}<br>
    | currentRowIndex: {{ currentRowIndex }}


  .debug2(v-if="constants.IS_DEBUG")
    | targetText: {{ targetText }}
    | inputText: {{ inputText }}
    | inputTexts: {{ inputTexts }}

  .targetText(
    v-if="targetText"
    ref="targetTextDOM"
  )
    .row(
      v-for="targetRow, i in targetRows"
      :class="{current: targetRow.isCurrent}"
      :ref="targetRow.isCurrent ? 'currentRowDOM' : 'rowDOM'"
    )
      .preview
        | {{targetRow.previewText}}
      .hiragana
        .character(
          v-for="targetCharacter, ci in targetRow.text"
          :class=`{
            matched: inputCharacters[i] && targetCharacter.value === inputCharacters[i][ci],
            wrong: inputCharacters[i] && inputCharacters[i][ci] && inputCharacters[i][ci] !== '＊' && targetCharacter.value !== inputCharacters[i][ci],
            current: i == currentRowIndex && targetCharacter.index === cleansedInputText.length
          }`
        ) {{inputCharacters[i] && inputCharacters[i][ci] ? inputCharacters[i][ci] : targetCharacter.value}}

  .clearMessage(:class="{ hidden: !isFinished }") お見事！
</template>

<script>
import * as _ from 'lodash'
import soundService from '@/services/SoundService'
import inputService from '@/services/InputService'
import * as constants from '@/constants'

export default {
  name: 'km-challenge-keyboard-input',
  components: {},
  props: {
    targetText: {
      default: () => []
    },
    targetPreviewText: {
      default: () => []
    }
  },
  filters: {},
  data() {
    return {
      constants,
      isReady: false,
      isFinished: false,
      preText: '',
      inputText: '',
      inputTexts: [''],
      inputCharacters: [],
      currentRowIndex: 0,
      leftHand: { x: 0, y: 2 },
      rightHand: { x: 0, y: 2 },
      currentKey: {},
      currentKeyResetTimer: null,
      backspaceCount: 0,
      isWronged: false,
      wrongCount: 0,
      wrongLogs: []
    }
  },
  computed: {
    targetRows: function() {
      if (!this.targetText || !this.targetPreviewText) return []
      // カウンターを使って全体でindexが割り振られるようにする
      let count = 0

      const rows = this.targetText.map((text, i) => {
        const textCharacters = text.split('')
        const textObject = textCharacters.map(character => {
          count += 1
          return {
            index: count - 1,
            value: character
          }
        })
        const row = {
          isCurrent: this.currentRowIndex === i,
          text: textObject,
          previewText: this.targetPreviewText[i]
        }
        return row
      })
      return rows
    },
    cleansedInputText: function() {
      return this.inputTexts.join('').replace(/＊+$/g, '')
    }
  },
  watch: {
    targetText: function() {
      this.reset()
    },
    inputTexts: {
      handler: _.debounce(function() {
          this.scrollToCurrentCharacter()
          this.inputCharacters = this.inputTexts.map((inputText) => inputText.split(''))
      }, 50)
    }
  },
  methods: {
    reset() {
      this.inputText = ''
      this.preText = ''
      this.isFinished = false
      this.isReady = true
    },
    focus() {
      this.$refs.self.focus()
    },
    /**
     * 入力文字列の追加
     */
    updateText(event) {
      this.inputText += '＊'
      if (!this.inputTexts[this.currentRowIndex]) this.inputTexts[this.currentRowIndex] = ''
      this.$set(this.inputTexts, this.currentRowIndex, this.inputTexts[this.currentRowIndex] + '＊')
      this.preText += event.key.toLowerCase()
    },
    /**
     * 仮入力分の変換を試みる
     */
    convertPreText() {
      if (inputService.isConvertable(this.preText) === false) {
        // n１回でも入力できるようにする
        if (inputService.isVaild(this.preText) === false && this.preText.charAt(0) === 'n') {
          this.inputText = this.inputText.slice(0, -2) + 'ん' + '＊'
          this.$set(this.inputTexts, this.currentRowIndex, this.inputTexts[this.currentRowIndex].slice(0, -2) + 'ん' + '＊')
          this.preText = this.preText.slice(1, 2)
          return true
        }
        return false
      }
      const matchedPattern = inputService.getPatternByRomaji(this.preText)
      if (_.isEmpty(matchedPattern)) return false
      this.inputText = this.inputText.slice(0, -matchedPattern.input.length) + matchedPattern.output
      if (!this.inputTexts[this.currentRowIndex]) this.inputTexts[this.currentRowIndex] = ''
      this.$set(this.inputTexts, this.currentRowIndex, this.inputTexts[this.currentRowIndex].slice(0, -matchedPattern.input.length) + matchedPattern.output)
      this.preText = ''
      return true
    },
    playHitSound(isCorrected, isConverted, keyY) {
      if (isCorrected) {
        if (isConverted) {
          soundService.play('vowel')
          return
        }
        switch (keyY) {
          case 1:
            soundService.play('keyUpper')
            break
          case 2:
            soundService.play('key')
            break
          case 3:
            soundService.play('keyLower')
            break
        }
      } else {
        soundService.play('fail')
      }
    },
    /**
     * 合否判定
     */
    checkAnswer() {
      const targetRow = this.targetText[this.currentRowIndex]
      const inputRow = this.inputTexts[this.currentRowIndex]
      const cleansedInputRow = inputRow.replace(/＊/g, '')
      const isCorrected = targetRow.indexOf(cleansedInputRow) === 0
      const isNewWrongCharacter = !isCorrected && this.isWronged === false
      if (isNewWrongCharacter) {
        this.isWronged = true
        this.wrongLogs.push({
          targetCharacter: targetRow.slice(
            cleansedInputRow.length - 1,
            cleansedInputRow.length
          ),
          inputCharacter: cleansedInputRow.slice(-1)
        })
      } else if (isCorrected) {
        this.isWronged = false
      }
      const isRowFinished = this.targetText[this.currentRowIndex] === this.inputTexts[this.currentRowIndex]
      if (isRowFinished) this.currentRowIndex += 1
      return isCorrected
    },
    scrollToCurrentCharacter() {
      if (_.isEmpty(this.$refs.currentRowDOM)) return
      let offsetTop = this.$refs.currentRowDOM[0].offsetTop
      const halfScreenSize = 309
      this.$refs.self.scrollTop = offsetTop - halfScreenSize
    },

    removeInput() {
      soundService.play('vanish')
      this.inputText = this.inputText.slice(0, -1)
      if (!this.inputTexts[this.currentRowIndex]) this.inputTexts[this.currentRowIndex] = ''
      this.$set(this.inputTexts, this.currentRowIndex, this.inputTexts[this.currentRowIndex].slice(0, -1))
      this.preText = this.preText.slice(0, -1)
    },

    /**
     * キーを押した時の処理
     */
    handleKeyDown(event) {
      if (
        (this.isReady === false && event.code !== 'Space') ||
        (this.isFinished && event.code !== 'Space')
      ) return

      const inputKey = inputService.getKeyDetail(event.code)
      const isInputAccepted = !_.isEmpty(inputKey)
      if (isInputAccepted) {
        const isOverInputted = (
          this.targetText[this.currentRowIndex] &&
          this.inputTexts[this.currentRowIndex] &&
          this.targetText[this.currentRowIndex].length <= this.inputTexts[this.currentRowIndex].length
        )
        if (this.preText === '' && isOverInputted) return
        this.updateText(event)
        const isConverted = this.convertPreText()
        const isCorrected = this.checkAnswer()
        this.playHitSound(isCorrected, isConverted, inputKey.y)
        if (!isCorrected) this.wrongCount += 1
        this.isFinished = this.targetText.join('') === this.inputTexts.join('')
        if (this.isFinished) {
          this.$emit('onInputFinished', {
            inputText: this.inputTexts.join(''),
            backspaceCount: this.backspaceCount,
            wrongLogs: this.wrongLogs,
            wrongCount: this.wrongCount
          })
        }
      } else { // 入力対象キー以外の場合
        if (event.code === 'Backspace') {
          this.backspaceCount += 1
          this.removeInput()
        }
        if (event.code === 'Space') {
          this.$emit('onSpaceKeyDown')
        }
      }
      this.$emit('onInput', {
        inputText: this.inputTexts.join(''),
        backspaceCount: this.backspaceCount,
        wrongLogs: this.wrongLogs,
        wrongCount: this.wrongCount
      })
    }
  },
  mounted() {
    this.$refs.self.focus()
    this.$refs.self.addEventListener('blur', this.focus)
  },
  beforeDestroy() {
    this.$refs.self.removeEventListener('blur', this.focus)
  }
}
</script>

<style lang="scss" scoped>
.debug {
  position: fixed;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  text-align: left;
  z-index: 10000;
}

.debug2 {
  position: fixed;
  right: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  z-index: 10000;
}

.ChallengeKeyboardInput {
  position: relative;
  top: 0;
  height: 100%;
  overflow: hidden;
  scroll-behavior: smooth;
  &:focus {
    outline: none;
  }
}

.targetText {
  margin: calc(25% - 75px) 0;
}

.row {
  position: relative;
  display: block;
  margin: 0 20px 8%;
  padding: 15px 60px;
  height: 150px;
  background: url(../../assets/scroll_body.png) repeat-x;
  background-size: 100% 100%;
  text-align: center;
  opacity: 0.5;
  transform: scale(0.9);
  box-sizing: border-box;

  &.current {
    transform: scale(1);
    opacity: 1;
  }

  &::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 0;
    display: block;
    width: 30px;
    height: 170px;
    background: url(../../assets/scroll_left.png) no-repeat;
    background-size: 100% 100%;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    width: 30px;
    height: 150px;
    background: url(../../assets/scroll_right.png) no-repeat;
    background-size: 100% 100%;
  }

  .preview {
    font-size: 5rem;
    font-weight: bold;
    font-family: serif;
  }

  .hiragana {
    font-size: 2.5rem;
    opacity: 0.9;
  }
}

// 文字
.character {
  display: inline-block;
  height: 45px;
  border-radius: 5px;
  transition-property: margin, padding, background, color, border-radius;

  &.current {
    background: orange;
  }

  &.matched {
    color: orange;
  }

  &.wrong {
    margin: 0 -3px;
    padding: 0 6px;
    background: red;
    color: #fff;
  }
}

.clearMessage,
.goodMessage {
  position: fixed;
  top: calc(50% - 100px);
  left: calc(50% - 300px);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 600px;
  height: 150px;
  border: 10px solid red;
  color: red;
  background: #fff;
  font-size: 60px;
  font-weight: bold;
  font-family: serif;
  opacity: 1;
  transform: scale(1.5) rotate(-15deg);
  transition-property: transform, opacity;

  &.hidden {
    transform: scale(0.5);
    opacity: 0;
  }
}

@keyframes blink {
  from,
  to {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}
</style>
